module.exports = __webpack_public_path__ + "static/media/orquestra.2a53859a.mp4";